// extracted by mini-css-extract-plugin
export default {"container":"CjoMrwZKDnrEcliqKE6_","customerInfo":"Ly7z8LfzJXM4rAOGMC6S","customerName":"S2TMgebo4AdS4VyGyGVN","additionalInfo":"rcqjs917aGOgYxMPhHu8"};